var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5940_28536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 0.665496V2.8035V0.665496ZM6.58333 2.8035V0.850963L0.791983 5.99883L6.584 11.1473V9.39083V8.52948L7.43716 8.64796C9.09632 8.87836 13.087 9.95999 15.2452 14.9044C15.149 10.6079 13.6062 7.92609 11.8926 6.24614C10.1022 4.49082 8.07108 3.77797 7.13898 3.52788L6.58333 3.37879V2.8035ZM6.66744 11.3322L6.66775 11.3302L6.66744 11.3322Z",
    stroke: "#007AFF",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5940_28536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 16 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLink);
export default __webpack_public_path__ + "static/media/share-link.73c30f4659155bdc6a5861aafa73e864.svg";
export { ForwardRef as ReactComponent };